import { observer } from 'mobx-react';
import React, { useMemo } from 'react';

import { useUserVehicles } from '@hooks';
import { Select } from 'antd';

interface IProps {
  userId?: number;
  placeholder?: string;
  mode?: 'multiple' | 'tags';
  status?: 'error' | 'warning';
  stickyHeader?: boolean;
  onClear?: () => void;
  onSelect?: (regNumber: string) => void;
  onDeselect?: (regNumber: string) => void;
  value?: string | null;
  allowClear?: boolean;
  defaultActiveFirstOption?: boolean;
}

export const UserVehicleSelect: React.FC<IProps> = observer(
  ({
    userId,
    status,
    stickyHeader,
    onSelect,
    onClear,
    onDeselect,
    value,
    mode,
    allowClear = true,
    defaultActiveFirstOption = false,
  }) => {
    const { userVehicles } = useUserVehicles(userId);

    const options = useMemo(() => {
      return userVehicles.map((userVehicle) => ({
        label: userVehicle.vehicle.registrationNumber,
        value: userVehicle.vehicle.registrationNumber,
      }));
    }, [userVehicles]);

    return (
      <Select
        mode={mode}
        disabled={!userId}
        allowClear={allowClear}
        style={{ width: '100%' }}
        status={status}
        options={options}
        value={value}
        onClear={onClear}
        onSelect={onSelect}
        onDeselect={onDeselect}
        placeholder="Please select a vehicle"
        defaultActiveFirstOption={defaultActiveFirstOption}
        getPopupContainer={(stickyHeader && ((trigger: any) => trigger.parentElement)) || undefined}
      />
    );
  }
);
